var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader'):_c('div',{staticClass:"page"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"main-text"},[_vm._v("النظام الداخلي للمدرسة")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.conductCode?.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }